import React, { useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import { GetUnApprovedInvoiceCountPayloadType } from "../../../commonTypes/thinksToDoTypes";
import {
  getWeeklyApprovedUsersInvoiceEntriesCountAction,
  resetUsersWeeklyApprovedInvoiceTotalCount,
} from "../../../redux/thinksToDo";
import { WeeklyTargetEntriesIcon } from "../../../assets/images";
import { Progress } from "reactstrap";
import BoxLoader from "../../commons/BoxLoader/BoxLoader";
type AppProps = {
  token: string | null;
  type?: string;
  fetching: boolean;
  approvedInvoiceTotalCount: number;
  usersWeeklyTargetCount: number;
  dispatchResetUsersWeeklyApprovedInvoiceTotalCount: () => void;
  dispatchGetWeeklyApprovedUsersInvoiceEntriesCountAction: (
    data: GetUnApprovedInvoiceCountPayloadType
  ) => void;
};

const WeeklyApprovedUsersInvoiceEntriesCountCard = ({
  token,
  fetching,
  type,
  approvedInvoiceTotalCount,
  usersWeeklyTargetCount,
  dispatchResetUsersWeeklyApprovedInvoiceTotalCount,
  dispatchGetWeeklyApprovedUsersInvoiceEntriesCountAction,
}: AppProps) => {
  useEffect(() => {
    dispatchResetUsersWeeklyApprovedInvoiceTotalCount();
    if (token) {
      const finalData = {
        token,
      };
      dispatchGetWeeklyApprovedUsersInvoiceEntriesCountAction(finalData);
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {fetching ? (
        <BoxLoader
          style={{ height: "99px", width: type?.length ? "100%" : "99%" }}
        />
      ) : (
        <>
          {usersWeeklyTargetCount > 0 ? (
            <div
              className="d-flex justify-content-left mb-3"
              style={{
                height: "90px",
                width: type?.length ? "100%" : "99%",
                backgroundColor: "#ffffff",
                border: "1px solid #bfcbe1",
                borderRadius: "5px",
              }}
            >
              <div className="ml-3" style={{ width: "5%", marginTop: "10px" }}>
                <img height="54px" src={WeeklyTargetEntriesIcon} alt="target" />
              </div>
              <div className="ml-2" style={{ width: "89%", marginTop: "10px" }}>
                <div className="mb-2">
                  <span
                    style={{
                      color: "#262a44",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    Weekly Entries Target
                  </span>
                  <span
                    className="ml-3"
                    style={{
                      color: "#6e7491",
                      fontSize: "12px",
                      fontWeight: "500",
                    }}
                  >
                    (Weekly target resets on Sunday at 00:00 hrs. Stay diligent
                    and finish strong!)
                  </span>
                </div>
                <div className="mb-2">
                  <Progress
                    striped
                    style={{
                      height: "10px",
                      marginRight: "10px",
                      width: "100%",
                      backgroundColor: "#bfcbe1",
                    }}
                    value={approvedInvoiceTotalCount}
                    max={usersWeeklyTargetCount}
                    color="success"
                  ></Progress>
                </div>
                <div className="d-flex justify-content-between">
                  <span
                    style={{
                      color: "#28a745",
                      fontWeight: "500",
                      fontSize: "12px",
                    }}
                  >
                    {approvedInvoiceTotalCount}{" "}
                    {approvedInvoiceTotalCount === 1 ? "Entry" : "Entries"}
                  </span>
                  <span
                    style={{
                      color: "#262a44",
                      fontWeight: "500",
                      fontSize: "12px",
                    }}
                  >
                    {usersWeeklyTargetCount}{" "}
                    {usersWeeklyTargetCount === 1 ? "Entry" : "Entries"}
                  </span>
                </div>
              </div>
            </div>
          ) : null}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.thinksToDo.fetching,
  approvedInvoiceTotalCount: state.thinksToDo.approvedInvoiceTotalCount,
  usersWeeklyTargetCount: state.thinksToDo.usersWeeklyApprovedInvoiceTotalCount,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetWeeklyApprovedUsersInvoiceEntriesCountAction: (
    data: GetUnApprovedInvoiceCountPayloadType
  ) => dispatch(getWeeklyApprovedUsersInvoiceEntriesCountAction(data)),
  dispatchResetUsersWeeklyApprovedInvoiceTotalCount: () =>
    dispatch(resetUsersWeeklyApprovedInvoiceTotalCount()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WeeklyApprovedUsersInvoiceEntriesCountCard);
